import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  const d = contactData;

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 mb-4">
            <i className="ri-send-plane-line text-accent-600 text-sm"></i>
            <span className="text-accent-700 text-xs font-medium">联系我们</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            {d.title}
          </h2>
          <p className="text-xl md:text-2xl text-accent-500 font-heading font-bold mb-4">
            {d.subtitle}
          </p>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-xl mx-auto mb-8">
            {d.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            {d.methods.map((method) => (
              <div
                key={method.label}
                className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center transition-all duration-200 hover:border-primary-200"
              >
                <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className={`${method.icon} text-accent-600 text-xl`}></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">{method.label}</div>
                <div className="font-bold text-sm text-foreground-900">{method.value}</div>
              </div>
            ))}
          </div>

          <div className="inline-flex items-start gap-2 px-5 py-3 rounded-xl bg-accent-50 border border-accent-200/60 max-w-lg mx-auto">
            <i className="ri-information-line text-accent-600 text-sm mt-0.5 flex-shrink-0"></i>
            <p className="text-xs text-foreground-600 text-left leading-relaxed">{d.tips}</p>
          </div>
        </div>
      </div>
    </section>
  );
}